module.exports = __webpack_public_path__ + "static/media/TNC.a208c42a.jpg";